import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { postOrderDetail, postTracking, postStoreCart, getCartLogin, postWarrantyRedeemSubmit } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import ReviewForm from '../../components/ReviewForm/ReviewForm';
import { MdFileDownload } from "react-icons/md";
import { FaShieldHalved, FaCodeBranch, FaCartShopping, FaCircleCheck, FaTicket, FaCommentDots, FaArrowRotateLeft, FaCheck } from "react-icons/fa6";
import Sidebar from '../../includes/Sidebar';
import { useFormik } from 'formik';
import { ReplacementSchema } from '../../schemas';

const OrdersDetails = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;
  const slug = pathname.split("/").pop() + search;
  const [cart, setCart] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isLoadings, setLoadings] = useState(true);
  const [data, setData] = useState([]);
  const [otherProduct, setOtherProduct] = useState([]);
  const [warranty, setWarranty] = useState([]);
  const [replacementData, setReplacementData] = useState([]);
  const [istracking, setIsTracking] = useState(false);
  const [tracking, setTracking] = useState([]);
  const [ismsg, setisMsg] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFiles(droppedFiles);
  };

  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  const handleFiles = (fileList) => {
    const validFiles = fileList.filter(file =>
      file.type.startsWith('image/') || file.type === 'application/pdf'
    );
    setFiles(prev => [...prev, ...validFiles]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const removeFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('dragover');
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove('dragover');
  };

  const initialValues = {
    warrantyNumber: '',
    remarks: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ReplacementSchema,
    onSubmit: async (values) => {
      setLoading(true);

      const formData = new FormData();
      formData.append('order_hash', slug);
      formData.append('warranty_number', values.warrantyNumber);
      formData.append('remarks', values.remarks);

      if (files && files.length > 0) {
        Array.from(files).forEach((file) => {
          formData.append('images[]', file);
        });
      }
      try {
        const res = await postWarrantyRedeemSubmit(formData);
        //toast.success(res.data.message);
        setLoading(false);
        setFiles([]);
        formik.resetForm();

      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    },
  });
  const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const postTrackings = async (datatrak) => {
    try {
      const res = await postTracking(datatrak);
      setTracking(res.data.data);
      setIsTracking(true);
      setLoading(false);
      setLoadings(false);
    } catch (error) {
      setIsTracking(false);
      setLoading(false);
      setLoadings(false);
    }
  };

  const postOrderDetails = async (postdata) => {
    try {
      const res = await postOrderDetail(postdata);
      setData(res.data.data);
      setOtherProduct(res.data.data?.other_product);
      setWarranty(res.data.data?.warranty);
      scrollToTop();
      if (res.data.data.status == 'APT' || res.data.data.status == 'FLD') {
        setIsTracking(false);
        setLoading(false);
        setLoadings(false);
      }
      else {
        let datatrak =
        {
          "airwaybill_hash": res.data.data.shipment.airwaybill_hash || '',
        }
        postTrackings(datatrak);
      }
    } catch (error) {
      setLoading(false);
      setLoadings(false);
      setisMsg(true);
    }
  };

  useEffect(() => {
    setLoadings(true);
    if (!localStorage.getItem('userToken')) {
      navigate("/");
    }
    else {
      let postdata =
      {
        "order_hash": slug,
      }
      postOrderDetails(postdata);
    }

  }, [slug])

  const handleDownload = (pdfUrl, orderno) => {
    var link = document.createElement("a");
    link.href = pdfUrl;
    link.setAttribute("download", `${orderno}.pdf`);
    link.click();
    link.remove();
  };

  const postCartData = async (postdata) => {
    try {
      const res = await postStoreCart(postdata);
    } catch (error) {
      console.log(error);
    }
  };

  const updateLoginCartAPI = async () => {
    try {
      const res = await getCartLogin();
    } catch (error) {
    }
  };

  useEffect(() => {
    if (localStorage.getItem('userToken')) {
      const storedCart = JSON.parse(localStorage.getItem('cart')) || [];

      setCart(storedCart);

      if (!storedCart?.length) {
        updateLoginCartAPI();
      }
      else {
        postCartData(storedCart);
        updateLoginCartAPI();
      }
    }
    setLoading(true);
  }, [])

  useEffect(() => {
    formik.resetForm();
  }, [modalShow])

  const handleClose = () => {
    setModalShow(false);
    setHistoryModal(false);
  };

  return (
    <>
      <Header CartTot={cart.length} toast={toast} />
      <ToastContainer />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {ismsg ? (
            <div className='nodata'>
              <h2>Order Details Not Found</h2>
              <div className='buttonbox'>
                <Link className='btn btn-green' to={'/myorders'}>Back to My Orders</Link>
              </div>
            </div>
          ) : (
            <>
              <div className="crumbsec">
                <div className="wrap">
                  <Link to={'/'}>Home</Link>
                  <span className="sep">&rsaquo;</span>
                  <Link to={'/profile'}>My Account</Link>
                  <span className="sep">&rsaquo;</span>
                  <Link to={'/myorders'}>My Orders</Link>
                  <span className="sep">&rsaquo;</span>
                  <span className="cur">Order Details</span>
                </div>
              </div>

              <main className="main" style={{ paddingBottom: '50px' }}>
                <Container>
                  <div className="layout">
                    <Sidebar />
                    <section id='orderDetails' className="content">
                      <div className="order-head">
                        <div>
                          <h1>Order Details <span className="pill " style={{ backgroundColor: data?.transaction?.status_color }}>{data?.order_status?.status_name}</span></h1>
                          <div className="order-meta">
                            <span>Order ID: <b>#{data?.order_no}</b></span>
                            <span>Placed on: <b>{data?.order_date}</b></span>
                            <span>Payment: <b>{data?.payment_type}</b></span>
                            <span><b>{`₹${data?.grand_total}`}</b></span>
                            <span>Payment Status: <b style={{ color: data?.transaction?.status_color }}>{data?.transaction?.payment_status}</b></span>
                          </div>
                        </div>
                        <br />
                        {data?.invoice.length > 0 && (
                          <Link className="dl-invoice" onClick={() => handleDownload(data?.invoice?.invoice_url, data?.order_no)}><MdFileDownload /> Download Invoice</Link>
                        )}
                      </div>

                      <section className="cardprodss">
                        <div className="sec-label">Product Details</div>
                        <div className="prod-body">
                          <div className="prod-img">
                            {data?.details?.is_combo ?
                              <Link to={`/bundle-deals/${data.details.slug}`}><img src={data?.details?.combo_thumbnail} alt='' title='' /></Link>
                              :
                              <Link to={`/product/${data.details.slug}`}><img src={data?.details?.media_list[0]?.media_url} alt='' title='' /></Link>
                            }
                          </div>
                          <div className="prod-info">
                            {data?.details?.is_combo ?
                              <Link to={`/bundle-deals/${data.details.slug}`}><h3>{data?.details.name}</h3></Link>
                              :
                              <Link to={`/product/${data.details.slug}`}><h3>{data?.details.name}</h3></Link>
                            }
                            <div className="prod-qp"> <span>Price: <b>{`₹${data.details.price}`}</b></span></div>
                          </div>
                        </div>
                      </section>

                      {data?.order_status?.status_name == 'Failed' ? null :
                        <>
                          {warranty.length > 0 ? (
                            <section className="cardtabs-card">
                              <div className="warr-body">
                                <div className="warr-head">
                                  <div>
                                    <h4>Replacement - Your Warranty Units ({warranty?.length})</h4>
                                    <p>Request replacement for any unit by entering its unique serial number.</p>
                                  </div>
                                  <button onClick={() => setModalShow(true)} className="btn-teal"><FaArrowRotateLeft /> Request Replacement</button>
                                </div>
                                {warranty.map((item, index) => {
                                  return (
                                    <div className={item?.status == 'Active' ? "unit" : "unit expired"} key={`Warranty_${index}`}>
                                      <div className="u-ic"><FaShieldHalved /></div>
                                      <div>
                                        <div className="u-name">Warranty Unit #{index + 1}</div>
                                        <div className="u-sub">Purchased on {item?.purchase_date}</div>
                                      </div>
                                      <div className="u-col">
                                        <div className="lbl">Warranty Status</div><span className={item?.status == 'Active' ? "pill green" : "pill red"}>{item?.status}</span>
                                      </div>
                                      <div className="u-col">
                                        <div className="lbl">Valid Till</div>
                                        <div className="u-val">{item?.expiry_date}</div>
                                      </div>
                                      <div className="u-col">
                                        <div className="lbl">Replacements Used</div>
                                        <div className="u-val">{item?.no_of_replacement - item?.remaining_replacement} / {item?.no_of_replacement}</div>
                                        <div className="bar"><i style={{ width: 0 }}></i></div>
                                        <div className="u-note">{item?.remaining_replacement} replacements remaining</div>
                                      </div>
                                      {item?.replacement_requests.length > 0 ? <button className="btn-out" onClick={() => { setHistoryModal(true); setReplacementData(item?.replacement_requests); }}>View History</button> :
                                        <button className="btn-out" disabled>View History</button>}
                                    </div>
                                  );
                                })}
                              </div>
                            </section>
                          ) : null}

                          {istracking ?
                            <section className="cardship">
                              <div className="sec-label">Shipping Details</div>
                              <div className="ship-grids">
                                <div className="ship-col">
                                  <div className="h">Courier : <span>{tracking?.courier}</span></div>
                                  <div className="h">Expected Delivery : <span>{tracking?.expected_delivery}</span></div>
                                </div>

                                <div className="timeline">
                                  {tracking?.history.map((item, index) => {
                                    return (
                                      <div className="tl" key={`setps_${index}`}>
                                        <div className="dot"><FaCheck /></div>
                                        <div>
                                          <div className="tt">{item.remarks}</div>
                                          <div className="td">{item.location}</div>
                                          <div className="td">{item.updated_at}</div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                  {/* <div className="tl">
                                <div className="dot"><i className="fa-solid fa-check"></i></div>
                                <div>
                                  <div className="tt">Shipped</div>
                                  <div className="td">13 May 2025, 07:45 PM</div>
                                </div>
                              </div>
                              <div className="tl">
                                <div className="dot"><i className="fa-solid fa-check"></i></div>
                                <div>
                                  <div className="tt">Out for Delivery</div>
                                  <div className="td">15 May 2025, 08:15 AM</div>
                                </div>
                              </div>
                              <div className="tl">
                                <div className="dot"><i className="fa-solid fa-check"></i></div>
                                <div>
                                  <div className="tt">Delivered</div>
                                  <div className="td">15 May 2025, 02:35 PM</div>
                                </div>
                              </div> */}
                                </div>

                                {/* <div className="delivered-box">
                            <div>
                              <div className="dh">Delivered</div>
                              <div className="dt">Your order has been delivered on 15 May 2025 at 02:35 PM</div>
                            </div>
                            <div className="dbox"><i className="fa-solid fa-box"></i><span className="chk"><i
                              className="fa-solid fa-check"></i></span></div>
                          </div> */}
                              </div>
                            </section>
                            : null}
                        </>
                      }

                      {otherProduct.length > 0 ? (
                        <section className="cardtabs-card other">
                          <div className="warr-body">
                            <h4>Other Items in this Order ({otherProduct.length})</h4>
                            <div className="other-grid">
                              {otherProduct.map((item) => {
                                return (
                                  <div className="oitem">
                                    <div className="oimg">
                                      {item?.is_combo ?
                                        <Link to={`/myorders/${item.order_hash}`}><img src={item?.combo_thumbnail} alt='' title='' /></Link>
                                        :
                                        <Link to={`/myorders/${item.order_hash}`}><img src={item?.media_list[0]?.media_url} alt='' title='' /></Link>
                                      }
                                    </div>
                                    <div className='contentsoitem'>
                                      <div className="onm"><Link to={`/myorders/${item.order_hash}`}>{item.name}</Link></div>
                                      <div className="oqp"><b>{`₹${item.price}`}</b></div>
                                    </div>
                                    <Link className="btn-detail" to={`/myorders/${item?.order_hash}`}>View Details <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.4"><path d="m9 6 6 6-6 6" /></svg></Link>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </section>
                      ) : null}

                      {data?.order_status?.status_name == 'Failed' ? null :
                        <>
                          <section className="cardtabs-card">
                            <div className="warr-body">
                              <ReviewForm toast={toast} OrderHash={slug} orderReview={data?.order_review} />
                            </div>
                          </section>
                        </>
                      }
                    </section>
                  </div>
                </Container>
              </main>
            </>
          )}
        </>
      )}

      <Modal id="replacementH" show={historyModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Replacement History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='replacementBox'>
            {replacementData.map((item) => {
              return (
                <div className='repcards'>
                  <div className={`statusbox ${item?.status}`}>{item?.status}</div>
                  <div className='repContent'>
                    <h4>Replacement: {item?.request_no}</h4>
                    <p>{item?.request_date}</p>
                    <p>{item?.status_text}</p>
                  </div>
                </div>
              )
            })}
          </div>
          <div className='modalfooters'>
            <div className='button-boxs'>
              <button type='button' onClick={handleClose} className='btn btn-red'>Close</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal id="Replacement" show={modalShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Request Replacement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='formsBoxs'>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="form-group">
                <label className="form-label">Warranty Number</label>
                <input
                  type='text'
                  id="warrantyNumber"
                  name="warrantyNumber"
                  className="form-control"
                  autoComplete='off'
                  value={values.warrantyNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.warrantyNumber && touched.warrantyNumber && (
                  <p className="errormsg">{errors.warrantyNumber}</p>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">Remarks</label>
                <textarea
                  type='text'
                  id="remarks"
                  name="remarks"
                  className="form-control"
                  autoComplete='off'
                  value={values.remarks}
                  onChange={handleChange}
                  onBlur={handleBlur}
                ></textarea>
                {errors.remarks && touched.remarks && (
                  <p className="errormsg">{errors.remarks}</p>
                )}
              </div>
              <div className="formsBox upload-container">
                <div
                  className="drop-zone"
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <p>Drag & Drop Here</p>
                  <p>or</p>
                  <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    className="select-button btn btn-green"
                  >
                    Select Files
                  </button>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                  />
                </div>

                {files.length > 0 && (
                  <div className="file-list mt-3">
                    <h6>Selected Files:</h6>
                    <ul className="list-group">
                      {files.map((file, index) => (
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                          <span>
                            {file.name} ({file.type})
                          </span>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => removeFile(index)}
                          >
                            Remove
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <div className='modalfooters'>
                <div className='button-boxs'>
                  <button type='submit' className='btn btn-green'>Save</button>
                  <button type='button' onClick={handleClose} className='btn btn-red'>Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <Footer toast={toast} />

      {isLoadings ? <Loader /> : null}
    </>
  )
}

export default OrdersDetails